import React, { Component, Fragment } from 'react';
// @ts-ignore
import parse from 'html-react-parser';

interface IProps {
  htmlInput: any;
}

interface IState {}

class ParseHtml extends Component<IProps, IState> {
  render() {
    const html = this.props.htmlInput;
    return <Fragment>{parse(html)}</Fragment>;
  }
}

export default ParseHtml;
